import React from 'react'
import Footer from '../../component/Footer/footer'
import Nav from '../../component/Nav/Nav'
import Section from '../../component/Section/Section'
const Home = () => {
  return (
    <div className={'w-screen'}>
    <Nav/>
    <Section/>
    <Footer/>
    </div>
  )
}

export default Home